import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'
import { PerPaymentCycleDropDownProps, PerPaymentCycleDropDown } from '../custom_components/PaymentCycleDropDown'

export type InputNumberProps = FormikFieldProps & Partial<PerPaymentCycleDropDownProps>

export const FormikPaymentCycleDropDown = ({ name, validate, disabled, earliestCycle, ...restProps }: InputNumberProps): JSX.Element => (
  <Field name={name} validate={validate}>
    {({ field: { value, name }, form: { setFieldValue } }: FieldProps) => (
      <PerPaymentCycleDropDown
        value={value}
        earliestCycle={earliestCycle}
        onChange={(value) => {
          setFieldValue(name, value)
        }}
        {...restProps}
        disabled={disabled}
      />
    )}
  </Field>
)
